import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from "react-bootstrap"
import {
    Modal,
    InputGroup,
    Container,
    Input,
    InputGroupAddon,
    InputGroupText,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { Document, Page } from 'react-pdf';
import { Form } from 'react-bootstrap';
import archiveDocument from '../../api/archiveDocument';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import getDocument from '../../api/getDocument';
import commitObject from '../../api/commitObject';
import commitObjectLater from '../../api/commitObjectLater';
import getValidateFormDocuments from '../../api/getValidateFormDocuments';
import { useFormik } from 'formik';
import styled from "styled-components"
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"
import folderGif from '../../assets/images/Folder_motion.gif'
import pdfjs from "pdfjs-dist";
import Loader from '../utilities/loader';
import { showToastAction } from '../../redux/toastSlice';
import getDocumentsDynamicDisplay from '../../api/getDocumentsDynamicDisplay';
import { useQuery } from 'react-query';
import { Tooltip } from 'antd';
import nextIcon from '../../assets/svg/next.svg'
import prevIcon from '../../assets/svg/previous.svg'

const url = "https://cors-anywhere.herokuapp.com/http://www.pdf995.com/samples/pdf.pdf"

const FormArchive = () => {
    const dispatch = useDispatch()
    const selectedProject = useSelector(state => state.selectedProject);
    const [formData, setFormData] = useState({});
    const { form_name } = useParams();
    // const [data, setData] = useState({});
    const [uploadedDocument, setUploadedDocument] = useState([]);
    const [scannedDocument, setScannedDocument] = useState(null);
    const [docUpload, setDocUpload] = useState(false);
    const [fileData, setFileData] = useState([])
    const [fileDataName, setFileDataName] = useState('')
    const [fileError, setFileError] = useState(null)
    const [showModal, setShowModal] = useState(false);
    const [showFileUploadModal, setShowFileUploadModal] = useState(0);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [imgPreviewIndex, setImgPreviewIndex] = useState(0)
    const [uploadedDocumentIds, setUploadedDocumentIds] = useState([]);
    const [toggleForm, setToggleForm] = useState(false)
    const [pdfPageNumber, setPdfPageNumber] = useState({ currPage: 1, totalPage: 1 })
    const [decodedImage, setDecodedImage] = useState({})
    const [loading, setLoading] = useState(false)
    const [selectedDoc, setSelectedDoc] = useState(null)
    const [data, setData] = useState(null)
    const [filesProcessed, setFilesProcessed] = useState(0);
    const [columnsSize, setColumnsSize] = useState(null)


    pdfjs.GlobalWorkerOptions.workerSrc = "https://d2v5g.csb.app/pdf.worker.js";
    /* pdf viewer code start */
    // pdfjs.GlobalWorkerOptions.workerSrc =
    //     `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    /* pdf viewer code end */
    const history = useHistory();
    const userState = useSelector(state => state.user)

    const { isLoading, result } = useQuery(
        ["getDocumentsDynamicDisplay", selectedProject.name, form_name],
        () => getDocumentsDynamicDisplay(selectedProject.name, form_name, formData._id),
        {
            enabled: formData._id ? true : false, // La requête n'est exécutée que si formData existe
            onSuccess: (data) => {
                setSelectedDoc(data.data.data);
                setColumnsSize(data.data.data.columns_size)
            },
            onError: (err) => {
                console.log("error", err)
            }
        }
    );

    useEffect(() => {
        setPdfPageNumber({ currPage: 1, totalPage: 1 })
    }, [showModal])

    useEffect(() => {
        let value = '';
        var regex = /[!@#$%^&*(),?":{}|<>]/;

        let error = null;
        let imageURLs = []
        for (let i = 0; i < fileData.length; i++) {
            if (!regex.test(fileData?.[i]?.name)) {
                if (fileData?.[i]?.type === 'application/pdf') {
                    setDecodedImage(fileData?.[i])
                    renderPdfToImage(fileData?.[i])
                } else {
                    imageURLs.push(URL.createObjectURL(fileData[i]))
                }
                value = i === 0 ? fileData?.[i]?.name : value + ', ' + fileData?.[i]?.name
            } else {
                error = 'files name should not contain special characters'
                value = '';
                break;
            }
        }

        setUploadedDocument(imageURLs);
        setFileError(error)
        setFileDataName(value)
    }, [fileData, showModal])

    useEffect(() => {
        if (decodedImage?.type === 'application/pdf') {
            renderPdfToImage(decodedImage)
        }
    }, [pdfPageNumber?.currPage])

    const updateData = (key, value) => setData((prev) => ({ ...prev, [key]: value }))

    const handleFileChange = (e) => {
        let acceptedFileTypes = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg'];
        if (!acceptedFileTypes.includes(e.target.files[0].type)) {
            setFileError("Selected file type is not allowed");
        } else {
            const chosenFiles = Array.prototype.slice.call(e.target.files);
            setFileData(chosenFiles);
            setCurrentFileIndex(0); // Reset the index when new files are selected
            setTotalFiles(chosenFiles.length); // Set the total number of files
            setFilesProcessed(0); // Reset the number of files processed
        }
    }

    const renderPdfToImage = (pdf_file) => {
        let reader = new FileReader();
        reader.onload = function (e) {
            const data = atob(e.target.result.replace(/.*base64,/, ''));
            pdfjs.getDocument({ data }).then(function (pdf) {
                // you can now use *pdf* here
                // setPdfPageNumber({ ...pdfPageNumber, totalPage: pdf.numPages })
                setPdfPageNumber(prevState => ({ ...prevState, totalPage: pdf.numPages }));
                pdf.getPage(pdfPageNumber?.currPage).then(function (page) {
                    // you can now use *page* here
                    var viewport = page.getViewport(2.0);
                    var canvas = document.getElementById('upload_preview')
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    page.render({
                        canvasContext: canvas.getContext('2d'),
                        viewport: viewport
                    });
                });
                // setLoadDoc('')
            });
        };
        reader.readAsDataURL(pdf_file);
    }

    const handleSubmit = async () => {
        try {
            setLoading(true);
            for (let i = 0; i < fileData.length; i++) {
                await uploadFile(fileData[i]);
                setFilesProcessed(prev => prev + 1);
            }

            if (formik.values.upload_multipal_files) {
                dispatch(showToastAction({ message: "Successfully added object", showToast: true, severity: "success" }));
                setShowFileUploadModal(0);
                history.push("/form/" + form_name + '/drafts');
            }
        } catch (err) {
            console.log(err);
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }));
        } finally {
            setLoading(false);
        }
    }


    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('reader', formik.values.reader);
        formData.append('limit_parsed_pages', formik.values.limit_parsed_pages);
        formData.append('respect_carriage_return', formik.values.respect_carriage_return ? "1" : '0');
        formData.append('remove_special_characters', formik.values.remove_special_characters ? "1" : '0');
        formData.append('upload_multipal_files', formik.values.upload_multipal_files ? "1" : '0');

        const res = await archiveDocument(selectedProject.name, form_name, formData);
        if (res) {
            if (formik.values.upload_multipal_files) {
                let document_ids = res?.data?.data?.documents_id;
                for (let i = document_ids.length - 1; i >= 0; i--) {
                    const document = await getDocument(selectedProject.name, form_name, document_ids[i]);
                    const { _id, ...restData } = document.data.data[0];
                    await commitObjectLater(selectedProject.name, form_name, _id, restData);
                }

            } else {
                const document = await getDocument(selectedProject.name, form_name, res.statusText);
                setFormData(document.data.data[0]);
                setShowModal(true);
            }
        }
    }


    const handleCommit = async () => {
        try {
            // added document_id here...
            const { _id, ...restData } = formData
            const reqData = { ...restData, ...data } // reqData + les champs mis à jour
            await commitObject(selectedProject.name, form_name, _id, reqData)
            dispatch(showToastAction({ message: "Successfully added object", showToast: true, severity: "success" }))
            setShowModal(false)
            history.push("/form/" + form_name + '/documents');
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }
    const handleCommitLater = async () => {
        try {
            const { _id, ...restData } = formData
            await commitObjectLater(selectedProject.name, form_name, _id, restData)
            // await getValidateFormDocuments(selectedProject.name, form_name, formData?._id);
            dispatch(showToastAction({ message: "Successfully added object", showToast: true, severity: "success" }))
            // history.goBack();
            setShowModal(false)
            history.push("/form/" + form_name + '/drafts');
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }


    const formik = useFormik({
        initialValues: {
            reader: 'universalReader',
            limit_parsed_pages: 5,
            respect_carriage_return: true,
            remove_special_characters: false,
            upload_multipal_files: false,
        },
        onSubmit: values => {
            if (!fileError) {
                handleSubmit()
            }
        },
    });

    const handleClose = () => {
        setData(null)
        setShowModal(false)
    };

    const imageShowHandler = async (e, action) => {
        // let currentIndex = imgPreviewIndex;
        // if (action === 'prev') {
        //     currentIndex = currentIndex === 0 ? 0 : currentIndex - 1
        // } else if (action === 'next') {
        //     currentIndex = currentIndex === uploadedDocument.length - 1 ?
        //         uploadedDocument.length - 1 :
        //         currentIndex + 1
        // }
        // const document = await getDocument(selectedProject.name, form_name, uploadedDocumentIds[currentIndex]);
        // setFormData(document.data.data[0]);
        // setImgPreviewIndex(currentIndex)

        let currentPage = pdfPageNumber?.currPage;
        if (action === 'prev') {
            currentPage = currentPage === 1 ? 1 : currentPage - 1
        } else if (action === 'next') {
            currentPage = currentPage === pdfPageNumber?.totalPage ?
                pdfPageNumber?.totalPage :
                currentPage + 1
        }
        setPdfPageNumber({ ...pdfPageNumber, currPage: currentPage })
    }

    /* pdf viewer code for function */
    /*When document gets loaded successfully*/
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1);
    }

    const changePage = (offset) => {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    const previousPage = () => {
        changePage(-1);
    }

    const nextPage = () => {
        changePage(1);
    }
    /* end pdf viewer code for functiona */

    return (
        <>
            {loading && <Loader />}
            <div className="recent-activities">
                {/*---------------- form preview popup ------------ */}
                <Modal isOpen={showModal} toggle={handleClose} fullscreen={true} size="xl">
                    <ModalBody>
                        <DocumentContainer>
                            <ParsedForm data={selectedDoc ? selectedDoc[pdfPageNumber.currPage] : {}} updateData={updateData} selectedDocument={formData} userType={userState.user_type} pdfPageNumber={pdfPageNumber} columnsSize={columnsSize} />
                            <ScannedContainer className="border relative-box modal_scroll" style={{ padding: '0' }}>
                                {(uploadedDocument.length > 1 && imgPreviewIndex !== 0) ||
                                    (!uploadedDocument[imgPreviewIndex] && pdfPageNumber?.currPage !== 1) &&
                                    <Tooltip title="Précédent">
                                        <div className="arrow-icon-container left-arrow-icon" onClick={(e) => imageShowHandler(e, 'prev')}>
                                            <img src={prevIcon} alt="Previous Icon" className="arrow-icon" />
                                        </div>
                                    </Tooltip>
                                }
                                <ScannedHeading className='py-1'>
                                    <h3 className='data-extract text-base'>Fichier source</h3>
                                </ScannedHeading>
                                {!uploadedDocument[imgPreviewIndex] &&
                                    <canvas className="w-100" id="upload_preview" />
                                }
                                {uploadedDocument[imgPreviewIndex] &&
                                    <img
                                        src={uploadedDocument[imgPreviewIndex]}
                                        className="w-100"
                                        alt="document"
                                        id="preview"
                                    />
                                }
                                {(uploadedDocument.length > 1 && imgPreviewIndex !== uploadedDocument.length - 1) ||
                                    (!uploadedDocument[imgPreviewIndex] && pdfPageNumber?.currPage !== pdfPageNumber?.totalPage) &&
                                    <Tooltip title="Suivant">
                                        <div className="arrow-icon-container right-arrow-icon" onClick={(e) => imageShowHandler(e, 'next')}>
                                            <img src={nextIcon} alt="Next Icon" className="arrow-icon" />
                                        </div>
                                    </Tooltip>
                                }
                            </ScannedContainer>
                        </DocumentContainer>

                        <div className="flex gap-6 w-full mt-2">
                            <div className="w-full sm:w-4/5">
                                <label className="font-bold">Observations</label>
                                <textarea
                                    onChange={(e) => updateData('observations', e.target.value)}
                                    defaultValue={''}
                                    name="observations"
                                    id="observations"
                                    className="h-20 p-2 w-full border border-[#ced4da] rounded-md focus:outline-none"
                                ></textarea>
                            </div>
                            <div className="w-full sm:w-1/5 flex flex-col justify-center items-center">
                                <div className="flex flex-col w-full justify-center items-center gap-1.5">
                                    {selectedDoc?.num_detected_documents && (
                                        <p className="text-black text-base">Nombre de documents: <b>{selectedDoc?.num_detected_documents}</b></p>
                                    )}
                                    <p className="text-black text-base">Numéro de page: <b>{pdfPageNumber?.currPage} | {pdfPageNumber?.totalPage} </b></p>
                                </div>

                                <div className="mt-2.5 flex justify-center w-full gap-4">
                                    <Button variant='secondary' onClick={handleCommitLater}>Rejeter</Button>
                                    <Button variant='primary' onClick={handleCommit}>Valider</Button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    {/* <ModalFooter style={{
                        padding: '0.3rem 0.75rem',
                        borderTop: 'none'
                    }}>
                        <Button variant='secondary' onClick={handleCommitLater}>Rejeter</Button>
                        <Button variant='primary' onClick={handleCommit}>Valider</Button>
                    </ModalFooter> */}
                </Modal>

                {/* --------------- File upload progress popup ------------------- */}
                <Modal isOpen={showFileUploadModal !== 0} size="md" style={{
                    transform: 'translateY(-50%)',
                    top: '50%',
                    marginTop: '0',
                    marginBottom: '0', maxWidth: '400px'
                }}>
                    <ModalBody>
                        <row>
                            <img src={folderGif} alt='upload file' style={{
                                width: '230px', heigth: '100px', margin: "auto",
                                marginTop: '-15px'
                            }}
                            />
                        </row>
                        <h3 style={{ fontSize: '17px', marginTop: '-18px', textAlign: 'center' }}>{showFileUploadModal} Documents passed and uploaded as drafts</h3>
                    </ModalBody>
                </Modal>

                <div>
                    {/* <Document
                        file={url}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        <Page pageNumber={pageNumber} />
                    </Document>
                    <div>
                        <div className="pagec">
                            Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
                        </div>
                        <div className="buttonc">
                            <button
                                type="button"
                                disabled={pageNumber <= 1}
                                onClick={previousPage}
                                className="Pre"

                            >
                                Previous
                            </button>
                            <button
                                type="button"
                                disabled={pageNumber >= numPages}
                                onClick={nextPage}

                            >
                                Next
                            </button>
                        </div>
                    </div> */}
                    <h3 className="border-0">Archive document</h3>
                    <Form>
                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                            <Form.Label column sm="3">
                                Read With
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control
                                    name='reader'
                                    defaultValue={formik.values.reader}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    type="text"
                                    as="select"
                                >
                                    <option value="universalReader">Universal Reader</option>
                                    <option value="civilDocument">Civil Document</option>
                                    <option value="SonilogaDcrReader">Soniloga Dcr Reader</option>
                                    <option value="NotaireCIReader">Notaire CI Reader</option>
                                    <option value="PasseportNigerien">Passeport Nigerien</option>
                                </Form.Control>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                            <Form.Label column sm="3">
                                Path
                            </Form.Label>
                            <Col sm="3">
                                <div className="upload-btn-wrapper">
                                    <Form.Label>
                                        Browse
                                    </Form.Label>

                                    <Form.Control type="text" value={fileDataName} />
                                    <Form.Control
                                        name='file'
                                        accept='application/pdf, image/png, image/jpg, image/jpeg'
                                        multiple={formik.values.upload_multipal_files}
                                        onChange={handleFileChange}
                                        type="file"
                                        size="sm"
                                    />
                                    {fileError && <div style={{ color: 'red' }}>{fileError}</div>}
                                </div>
                            </Col>
                        </Form.Group>
                        {toggleForm
                            &&
                            <div>
                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                    <Form.Label column sm="3">
                                        Limit Number of pages to
                                    </Form.Label>
                                    <Col sm="1">
                                        <Form.Control
                                            type="text"
                                            name='limit_parsed_pages'
                                            defaultValue={formik.values.limit_parsed_pages}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                    <Form.Label column sm="3">
                                        Remove Special Characters
                                    </Form.Label>
                                    <Col sm="5" className="d-flex align-items-center">
                                        <Form.Check
                                            type={'checkbox'}
                                            defaultChecked={formik.values.remove_special_characters}
                                            name='remove_special_characters'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                    <Form.Label column sm="3">
                                        Respect Carriage Return
                                    </Form.Label>
                                    <Col sm="5" className="d-flex align-items-center">
                                        <Form.Check
                                            type={'checkbox'}
                                            name='respect_carriage_return'
                                            defaultChecked={formik.values.respect_carriage_return}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                    <Form.Label column sm="3">
                                        Upload Multiple Files
                                    </Form.Label>
                                    <Col sm="5" className="d-flex align-items-center">
                                        <Form.Check
                                            type={'checkbox'}
                                            name='upload_multipal_files'
                                            defaultChecked={formik.values.upload_multipal_files}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Col>
                                </Form.Group>
                            </div>}
                        <div>
                            <a
                                href=''
                                onClick={(e) => {
                                    e.preventDefault()
                                    setToggleForm(!toggleForm)
                                }}
                                style={{
                                    color: "blue"
                                }}
                            >
                                {toggleForm ? 'Hide...' : '...More options'}
                            </a>
                        </div>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">
                                <button
                                    type="button"
                                    class="mt-3 mr-3 btn btn-primary"
                                    onClick={() => formik.handleSubmit()}
                                >
                                    Archive
                                </button>
                            </Form.Label>
                        </Form.Group>
                    </Form>
                </div>
            </div>
        </>
    );
}

export default FormArchive;

const ScannedHeading = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
`

const DocumentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 100%;

    @media screen and (min-width: 1000px) {
        flex-direction: row;
    }
`

const ScannedContainer = styled.div`
    width: 100%;
    padding: 1.5rem;
`


function ParsedForm({ data, updateData, selectedDocument, userType, pdfPageNumber, columnsSize }) {
    const [mappableDocument, setMappableDocument] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inputValues, setInputValues] = useState({});

    const immutableCols = [
        "document_status", "datetime_insertion", "created_by", "last_modification_date",
        "modified_by", "final_storage_location", "image_name", "recycle", "archive", "new_doc"
    ];

    useEffect(() => {
        setIsLoading(true);
        // Use {} si data est null ou undefined
        let dynamicMappableDocument = Object.entries(data ?? {})
            .filter(([key, val]) => key !== "document_preprocessing" && key !== "_id" && key !== "total_pages" && key !== "observations" && key !== "mapping");

        dynamicMappableDocument = Array.isArray(dynamicMappableDocument) ? dynamicMappableDocument : [];

        setMappableDocument(dynamicMappableDocument);

        const initialInputValues = {};
        dynamicMappableDocument.forEach(([key, value]) => {
            initialInputValues[key] = value;
        });
        setInputValues(initialInputValues);

        setIsLoading(false);
    }, [data, selectedDocument, pdfPageNumber.currPage]);

    const handleInputChange = (key, value) => {
        console.log("value", value)
        setInputValues(prevValues => ({
            ...prevValues,
            [key]: value,
        }));
        updateData(key, value);
    };




    return (
        <Container className="border modal_scroll" style={{ padding: '0' }}>

            <h3 className="fw-bolder mb-2 data-extract text-base">Données extraites</h3>
            <div style={{ padding: '1rem 1rem 0.5rem' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // gap: immutableCols.includes(mappableDocument.map(([key]) => key)) ? 10 : 16,
                }}>
                    {!isLoading && mappableDocument.length !== 0 ? mappableDocument.map(([key, value], i) => <InputGroup
                        style={{
                            marginBottom: immutableCols.includes(key) ? 5 : 10,
                            maxWidth: immutableCols.includes(key) ? '' : '',
                            marginTop: key === 'document_status' ? 50 : ""
                        }}>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText
                                style={{
                                    fontSize: immutableCols.includes(key) ? "10px" : "",
                                    padding: immutableCols.includes(key) ? "2px 10px" : "",
                                    background: !immutableCols.includes(key) ? "rgb(63, 98, 116)" : "",
                                    color: !immutableCols.includes(key) ? "#fff" : "",
                                    borderColor: !immutableCols.includes(key) ? "rgb(63, 98, 116)" : "",
                                    width: !immutableCols.includes(key) ? 200 : 200,
                                    height: immutableCols.includes(key) ? 0 : '',
                                    minHeight: immutableCols.includes(key) ? 20 : ''
                                }}>
                                {key}
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            style={{
                                fontSize: immutableCols.includes(key) ? "10px" : "",
                                padding: immutableCols.includes(key) ? "2px 10px" : "",
                                height: immutableCols.includes(key) ? 0 : '',
                                minHeight: immutableCols.includes(key) ? 20 : ''
                            }}
                            type={columnsSize[key] === 1 ? "textarea" : "text"}
                            rows={columnsSize[key] === 1 ? 3 : undefined}
                            onChange={(e) => handleInputChange(key, e.target.value)}
                            disabled={immutableCols.includes(key) || (selectedDocument.document_status == "VALIDATED" && userType == "CAPTURE")}
                            defaultValue={value === true ? 1 : value === false ? 0 : value}
                            value={inputValues[key] || ''}
                        />
                    </InputGroup>)
                        : (!isLoading && mappableDocument.length === 0) ? <div className="flex items-center justify-center h-56">Page non identifiée.</div> : <div className="flex items-center justify-center h-56">Chargement...</div>}
                </div>
            </div>
        </Container>)
}